<template>
  <!-- 教师应用报告 -->
  <div class="paginations">
    <div class="table-search-box table-search-box-haeder">
      <el-form :inline="true" :model="searchData" class="demo-form-inline" v-if="!isExhibition">
        <el-form-item label="教师姓名">
          <el-input size="small" v-model="searchData.userName" placeholder="教师姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <div class="search_button">
            <i class="pointer el-icon-search" @click="click(searchData.userName)"></i>
            <i class="pointer el-icon-refresh-left" @click="isExhibition = false,searchData.userName = ''"></i>
          </div>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="batchExportHandler" class="exportButton">批量导出</el-button>
        </el-form-item> -->
      </el-form>
      <el-button class="recurrence" v-if="isExhibition" @click="isExhibition = false,searchData.userName = ''">返回</el-button>
    </div>
    <div class="table_box">
      <el-table :data="oneTableObj.list" ref="table" style="width: 100%" v-if="!isExhibition">
        <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
        <el-table-column type="index" label="序号" width="120" align='center'>
        </el-table-column>
        <el-table-column prop="userName" label="教师姓名" align='center'>
        </el-table-column>
        <el-table-column prop="loginName" label="账号" align='center'>
        </el-table-column>
        <el-table-column prop="institute" label="所属院校" align='center' width="350">
        </el-table-column>
        <el-table-column prop="userCode" label="工号" align='center'>
        </el-table-column>
        <el-table-column prop="sex" label="性别" align='center' width="50">
        </el-table-column>
        <el-table-column prop="province" label="所属省份" align='center'>
        </el-table-column>
        <el-table-column prop="Datekey" label="数据分析截止时间" align='center'>
        </el-table-column>
        <el-table-column label="操作" align='center'>
          <template slot-scope="scope">
            <i class="icona icon-see" title="查询教师应用报告" @click="see(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
      <pageNumber v-if="!isExhibition" :paginations="7" :pageNum="searchData.pageDto.pageNum" :pageSize="searchData.pageDto.pageSize" :total="oneTableObj.total" :jumpTo="oneTableObj.jumpTo" @currentChange="getList"></pageNumber>

      <!-- 二级表格 -->
      <!-- <el-table :data="towTableObj.list" style="width: 100%" v-if="isExhibition">
        <el-table-column prop="userName" label="姓名" align='center'></el-table-column>
        <el-table-column prop="userId" label="用户Id" align='center'></el-table-column>
        <el-table-column prop="loginName" label="账号" align='center'></el-table-column>
        <el-table-column prop="institute" label="学校" align='center'></el-table-column>
        <el-table-column prop="loginName" label="教工号" align='center'></el-table-column>
        <el-table-column prop="sex" label="性别" align='center' width="50"></el-table-column>
        <el-table-column prop="birthday" label="出生日期" align='center' width="110"></el-table-column>
        <el-table-column label="角色" align='center'>
          <template>
            <span>教师</span>
          </template>
        </el-table-column>
        <el-table-column prop="province" label="省份" align='center'></el-table-column>
        <el-table-column label="操作" align='center'>
          <template slot-scope="scope">
            <i class="icona icon-see" title="查询教师应用报告" @click="see(scope.row)"></i>
            <i class="icona icon-details" title="查看年度个性化报告" @click="see(scope.row.personYearReportFilePath)"></i>
            <i class="icona icon-download" title="下载年度个性化报告" @click="download(scope.row.personYearReportFilePath)"></i>
          </template>
        </el-table-column>
      </el-table> -->
    </div>
  </div>
</template>

<script>
import pageNumber from '@/components/pageNumber.vue'; // 分页

export default {
  components: {
    pageNumber,
  },
  data() {
    return {
      searchData: {
        userName: '',
        pageDto: {
          pageNum: 1, // 当前显示的页面页码数
          pageSize: 10, // 一页多少条数据
        },
      },
      DateStr: '',
      oneTableObj: {
        total: 0,
        jumpTo: 1,
        list: [],
      },

      towTableObj: {
        list: [],
      },

      isExhibition: false, // 是否显示二级表格
    };
  },
  created() {
    this.getList();
    // 格式化时间日期
    let str = '-'
    let date = new Date()
    let Year = date.getFullYear()
    let Month = date.getMonth() + 1
    let Day = date.getDate()
    if (Month >= 1 && Month <= 9) Month = '0' + Month
    if (Day >= 1 && Day <= 9) Day = '0' + Day
    let currentDate = Year + str + Month + str + Day
    this.DateStr = currentDate
  },
  methods: {
    // 获取一级表格数据
    getList(type) {
      this.searchData.pageDto.pageNum = type || 1;
      this.oneTableObj.jumpTo = type || 1;
      this.$axios.post(this.$apiurls.applicationReport_getList, {
        pageDto: this.searchData.pageDto,
        statType: 6,
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          // for (let i = 0; i < res.data.list.length; i++) {
          //   if (this.searchData.pageDto.pageNum == 1) {
          //     res.data.list[i].index = i + 1;
          //   } else {
          //     res.data.list[i].index = i + 1 + ((this.searchData.pageDto.pageNum - 1) * 10);
          //   }
          // }
          this.oneTableObj.list = res.data.list;
          let DateKey = 'Datekey'
          let DateValue = this.DateStr
          this.oneTableObj.list.forEach(item => {
            item[DateKey] = DateValue
          })
          this.oneTableObj.total = res.data.total;
        }
      });
    },
    // 查询获取二级表格数据
    click(row) {
      this.$axios.post(this.$apiurls.applicationReport_getZykUserInfoVoByRole, {
        role: 2,
        userName: row || this.searchData.userName,
      }, {
        loading: false,
      }, { timeout: 3 * 60 * 1000 }).then((res) => {
        if (res) {
          this.oneTableObj.list = res.data;
        }
      });
    },

    // batchExportHandler() {
    //   let select = this.$refs.table.selection

    //   let selectZykidArr = select.map(item => {
    //     let zykid = item.userId
    //     return zykid
    //   })

    //   let selectNameArr = select.map(item => {
    //     let userName = item.userName
    //     return userName
    //   })

    //   let userId = selectZykidArr.join(",");
    //   let selectName = selectNameArr.join(",")

    //   this.$axios.post(this.$apiurls.exportBatchReport, {
    //     zykid: this.zykId,
    //     type: 1,
    //     param: { userid: userId, username: selectName }
    //   }).then(res => {
    //     window.open(`${this.$apiurls.downloadReport}?file_path=${res.data}`)
    //     // window.open(`${this.$apiurls.report_yaer_Monthly_downloadReportFile}?filePath=${res.data}`)
    //   })
    // },

    // 查看
    see(row) {
      const news = this.$router.resolve({ name: '/tInformation', query: { userId: encodeURIComponent(row.userId), userType: '教师' } });
      // const news = this.$router.resolve({ name: '/tInformation', query: { userId: encodeURIComponent(row.userName), userType: '教师' } });
      window.open(`${news.location.name}${news.href}`, '_blank');
    },
  },
};
</script>

<style  lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style  lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" >
.paginations {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.table-search-box-haeder {
  height: 40px;
  margin-bottom: 20px;
}

.recurrence {
  background: rgba(46, 62, 99, 0.79);
  color: #1bf6f8;
  border: 0px;
  font-size: 13px;
  padding: 9px 10px;
  margin-bottom: 10px;
}

.exportButton {
  width: 100px;
  height: 33px;
  margin-top: 5px;
  line-height: 0;
  background: rgba(46, 62, 99, 0.79);
  border: none;
}

.exportButton:hover {
  background: rgba(46, 62, 99, 0.79);
  border: none;
}

.exportButton:active {
  background: rgba(46, 62, 99, 0.79);
  border: none;
}
</style>
